import styled, { keyframes } from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";

export const NoResultsFoundText = styled.div`
  text-align: center;
  margin: 0;
  color: inherit;
`;

const fadeIn    = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const fadeOut   = keyframes`from { opacity: 1; } to { opacity: 0; }`;
const slideUp   = keyframes`from { transform: translateY(2%); opacity: 0; } to { transform: translateY(0); opacity: 1; }`;
const slideDown = keyframes`from { transform: translateY(0); opacity: 1; } to { transform: translateY(2%); opacity: 0; }`;

export const DialogOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 999999998;

    &[data-state="open"]   { animation: ${fadeIn}   200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${fadeOut} 150ms ease forwards;
        pointer-events: none;
    }
`;

export const DialogContent = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    display: flex;
    flex-direction: column;
    background: #000;
    z-index: 999999999;
    overflow: hidden;

    &[data-state="open"]   { animation: ${slideUp}   200ms ease forwards; }
    &[data-state="closed"] {
        animation: ${slideDown} 150ms ease forwards;
        pointer-events: none;
    }

    &:focus { outline: none; }
`;

export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    background: #111;
    flex-shrink: 0;
`;

export const ModalTitle = styled(Dialog.Title)`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
`;

export const CloseButton = styled(Dialog.Close)`
    background: transparent;
    border: none;
    color: #fff;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    padding: 0 4px;
    opacity: 0.7;

    &:hover { opacity: 1; }
`;

export const ModalBody = styled.div`
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;

    & > * {
        width: 100% !important;
        height: 100% !important;
    }
`;
